/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { supportsMobileScreenReader } from '../utils/UNSAFE_visUtils';
import type { GanttRowData, GanttTaskData } from './gantt.types';
import { GanttDesktopTaskAccContent } from './GanttDesktopTaskAccContent';
import { GanttMobileTaskAccContent } from './GanttMobileTaskAccContent';
import type { GanttViewportTaskLayoutObj, ViewportLayout } from './utils/dataLayoutUtils';

type Props<K1, K2, D1 extends GanttRowData<K1, D1, D2>, D2 extends GanttTaskData<K2>> = {
  width: number;
  height: number;
  rowData: ViewportLayout<K1, K2, D1, D2>['rowData'];
  dateFormatter: (date: string) => string;
  ariaActiveId?: string;
  ariaActiveTaskObj?: GanttViewportTaskLayoutObj<K2>;
  layoutObjs: ViewportLayout<K1, K2, D1, D2>['rowObjs'];
};

export function GanttTaskAccLayer<
  K1,
  K2,
  D1 extends GanttRowData<K1, D1, D2>,
  D2 extends GanttTaskData<K2>
>({
  width,
  height,
  rowData,
  dateFormatter,
  ariaActiveId,
  ariaActiveTaskObj,
  layoutObjs
}: Props<K1, K2, D1, D2>) {
  return supportsMobileScreenReader ? (
    <GanttMobileTaskAccContent
      width={width}
      height={height}
      layoutObjs={layoutObjs}
      rowData={rowData}
      dateFormatter={dateFormatter}
    />
  ) : (
    <GanttDesktopTaskAccContent
      width={width}
      height={height}
      rowData={rowData}
      dateFormatter={dateFormatter}
      ariaActiveId={ariaActiveId}
      ariaActiveTaskObj={ariaActiveTaskObj}
    />
  );
}
